import { useMemo } from "react";
import { useParameterFeasibility } from "hooks/useParameterFeasibility";
import { MaterialLimit, TargetBasketItem } from "src/store/api/generatedApi";
import { isMaterialLimitNullified } from "src/utils/materialLimitOverrides";

export const useMaterialLimitFeasibility = ({
  workingLimits,
  targetBaskets,
}: {
  workingLimits: MaterialLimit[] | null;
  targetBaskets: TargetBasketItem[] | null;
}) => {
  const request = useMemo(
    () =>
      workingLimits === null || targetBaskets === null
        ? null
        : {
            material_physics_overrides: null,
            material_chemistry_overrides: null,
            material_limits: workingLimits.filter(
              (limit) => !isMaterialLimitNullified(limit)
            ),
            target_baskets: targetBaskets,
          },
    [workingLimits, targetBaskets]
  );
  return useParameterFeasibility(request);
};
